import { ContactGroupMap } from "../../services/cellcast.v2.types"

export const getValueByFields = (contact: ContactGroupMap, fieldName: string): string => {
    const field = contact?.fields?.find((f) => f.name === fieldName)
    return field?.value || ''
  }
